import React from 'react';
import I18n from 'i18n-js';

import stayContactableSvg from '../../public/images/stay-contactable.svg';
import styles from './stay-contactable-card.less';

const StayContactableCard = () => (
  <div className={styles.container}>
    <img
      className={styles.image}
      src={stayContactableSvg}
      alt="stay_contactable"
    />
    <div className={styles.content}>
      <div className={styles.title}>{I18n.t('stayContactableCard.title')}</div>
      <div className={styles.subtitle}>
        {I18n.t('stayContactableCard.subtitle')}
      </div>
    </div>
  </div>
);

export default StayContactableCard;
